/**
 * Sentry 去重标记
 *
 * 防止同一 error 对象被多次 captureException
 */

export const SENTRY_HANDLED = Symbol.for("sentryHandled");

export function isSentryHandled(error: unknown): boolean {
  return (
    error != null &&
    typeof error === "object" &&
    (error as Record<symbol, unknown>)[SENTRY_HANDLED] === true
  );
}

export function markSentryHandled(error: unknown): void {
  if (error != null && typeof error === "object") {
    (error as Record<symbol, unknown>)[SENTRY_HANDLED] = true;
  }
}

export function isAnySentryHandled(errors: readonly unknown[]): boolean {
  return errors.some(isSentryHandled);
}

export function markAllSentryHandled(errors: readonly unknown[]): void {
  for (const error of errors) {
    markSentryHandled(error);
  }
}
